import React from 'react';
import StyledLinksColumn from '../../ui-library/styled/StyledLinksColumn';
import { trackFooterNavigateClick } from '../tracking/discovery.tracking';
import {
  STR_ABOUT_US,
  STR_CONTACT_US,
} from '../tracking/discovery.tracking.constants';
import StyledLink from './StyledLink';

const trackAboutUsClick = () => {
  trackFooterNavigateClick(STR_ABOUT_US);
};

const trackContactUsClick = () => {
  trackFooterNavigateClick(STR_CONTACT_US);
};

const ContactLinks = () => {
  return (
    <StyledLinksColumn>
      <StyledLink to='/about-us' onClick={trackAboutUsClick}>
        About us
      </StyledLink>
      <StyledLink to='/contact-us' onClick={trackContactUsClick}>
        Contact us
      </StyledLink>
    </StyledLinksColumn>
  );
};

export default ContactLinks;
